import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { authService } from '../services/auth.service.ts';
import { getEmailVerificationStatus } from '../utils/emailVerification.ts';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const onVerifyPage = location.pathname.startsWith('/verify-email');

  const [checking, setChecking] = useState(true);
  const [isLocked, setIsLocked] = useState(false);

  useEffect(() => {
    if (!authService.isAuthenticated()) {
      setChecking(false);
      return;
    }

    let active = true;
    const localLocked = getEmailVerificationStatus(authService.getUser()).isLocked;

    // Yerelde kilit yoksa hızlı geç; kilit varsa sunucudan doğrulama durumunu tazele.
    if (!localLocked) {
      setIsLocked(false);
      setChecking(false);
      return;
    }

    void (async () => {
      try {
        const fresh = await authService.fetchProfile();
        if (!active) return;
        setIsLocked(getEmailVerificationStatus(fresh).isLocked);
      } catch {
        if (!active) return;
        setIsLocked(true);
      } finally {
        if (active) setChecking(false);
      }
    })();

    return () => {
      active = false;
    };
  }, [location.pathname]);

  if (!authService.isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (checking) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center text-gray-300 gap-3">
        <Loader2 className="w-5 h-5 animate-spin" />
        Hesap kontrol ediliyor...
      </div>
    );
  }

  if (isLocked && !onVerifyPage) {
    return <Navigate to="/verify-email" replace />;
  }

  return <>{children}</>;
}

export default PrivateRoute;
